





















































import Vue from 'vue'
import ConfirmCheckbox from '@/components/ConfirmCheckbox.vue'
import EmailValidation from '@/service/EmailValidation'
import { Article } from '@/model/Article'

export default Vue.extend({
  name: 'Newsletter',
  components: {
    ConfirmCheckbox,
  },
  mounted() {
    this.fetchTerms()
  },
  data: () => ({
    confirmSubscriptionDialog: false,
    termsAndConditions: null as Article | null,
    emailRules: [
      (v: string) => !!v || 'E-mail is required.',
      (v: string) =>
        EmailValidation.isValid(v) || 'Enter correct e-mail address.',
    ],
    email: '',
    subscriptionSaveLoading: false,
  }),
  methods: {
    fetchTerms: function () {
      this.$api
        .get('/articles/slug/newsletter-terms-and-conditions')
        .then((response) => (this.termsAndConditions = response.data))
    },
    showConfirmSubscriptionDialog: function () {
      this.confirmSubscriptionDialog = true
    },
    resetNewsletterForm: function () {
      this.email = ''
      ;(this.$refs.newsletterFormRef as any).resetValidation()
    },
    confirmLongTextInput: function (value: boolean) {
      if (!value) {
        this.resetNewsletterForm()
      }
    },
    subscribe: async function () {
      this.subscriptionSaveLoading = true
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('newsletter')
      this.$api
        .post('/newsletter_emails', { email: this.email, token: token })
        .then(() => {
          this.$store.dispatch(
            'alert/success',
            'Thanks for subscribing our newsletter. Check your inbox for the verification e-mail.'
          )
        })
        .finally(() => {
          this.subscriptionSaveLoading = false
          this.confirmSubscriptionDialog = false
          this.resetNewsletterForm()
          ;(this.$refs as any).confirmCheckboxDialog.resetForm()
        })
    },
  },
})
